<template>
  <v-container fluid>
    <Window
      name="Verbale Tecnico GVR"
      v-model="record_id"
      ref="window"
      @copyCancelled="close"
      @delete="close"
      hide-copy
    ></Window>
    <v-flex d-flex>
      <v-btn text :disabled="!record_id" @click="downloadVerbale"
        ><v-icon>mdi-download</v-icon>Download Verbale</v-btn
      >
      <v-spacer></v-spacer>
      <v-btn text color="error" @click="close">Chiudi</v-btn>
    </v-flex>
  </v-container>
</template>

<script>
/* eslint-disable */
import mixin from "../mixin/MixingCommonComp";
import Window from "@/components/Window.vue";

export default {
  mixins: [mixin],
  components: { Window },
  data() {
    return {
      record_id: 0,
    };
  },
  methods: {
    close() {
      this.$router.push({ path: "/ricercaVerbale" });
    },
    downloadVerbale() {
      this.$store.commit("setProgressMessage", "Download in corso");
      this.$store.commit("setProgressLoading", true);
      let parameters = {};
      parameters.idempiereRestPath = "print/addPrintJob";
      let data = {};
      data.parameters = "{id:" + this.record_id + "}";
      data.nomeStampa = "Verbale Tecnico GVR 2025";
      parameters.data = data;
      this.$store.dispatch("callIdempiereRest", parameters).then((response) => {
        if (response.data.hasOwnProperty("file")) {
          const linkSource =
            "data:application/pdf;base64," + response.data.file;
          const downloadLink = document.createElement("a");
          const fileName = this.$refs.window.getValue("nomeverbale")+".pdf";

          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
          this.$store.commit("setProgressMessage", null);
        } else {
          this.$store.commit("setProgressMessage", null);
          var errorMsg = "Download non riuscito";
          if (response.data.hasOwnProperty("message")) {
            errorMsg = errorMsg + "\n" + response.data.message;
          }
          this.$store.commit("setErrorMessage", errorMsg);
        }
      });
    },
  },
  mounted() {
    let datiVerbale = this.$store.state.datiVerbale;
    this.record_id = datiVerbale.fct_vertecnicogvr_id;

    console.log(datiVerbale);

    setTimeout(async () => {
      /*while(!this.$refs.window.isDataFetched()){
        await new Promise(resolve => setTimeout(resolve, 1000));
      }*/

      this.$refs.window.setCopyValue(
        "C_OrderLine_ID",
        datiVerbale.c_orderline_id
      );

      if (datiVerbale.type == "N") {
        this.$refs.window.setValue("C_BPartner_ID", datiVerbale.c_bpartner_id);
        this.$refs.window.setValue(
          "C_OrderLine_ID",
          datiVerbale.c_orderline_id
        );
        this.$refs.window.setValue(
          "fct_scadverifiche_ID",
          datiVerbale.fct_scadverifiche_id
        );

        this.$refs.window.setCopyValue(
          "C_OrderLine_ID",
          datiVerbale.c_orderline_id
        );

        let parameters = {};
        parameters.data = {
          fct_scadverifiche_id: datiVerbale.fct_scadverifiche_id,
        };
        parameters.idempiereRestPath = "seritec/getDatiMacchina";
        let response = await this.$store.dispatch(
          "callIdempiereRest",
          parameters
        );
        let macchinario = response.data.macchinario;
        this.$refs.window.setValue("marcaturace", macchinario.certCE);
        this.$refs.window.setValue("ditta", macchinario.ditta);
        this.$refs.window.setValue("costruttore", macchinario.costruttore);
        this.$refs.window.setValue(
          "matricolainail",
          macchinario.matricolaInail
        );
        this.$refs.window.setValue("nfab", macchinario.nFab);
        this.$refs.window.setValue("viaditta", macchinario.viaDitta);
        this.$refs.window.setValue("comuneditta", macchinario.comuneDitta);
        this.$refs.window.setValue("luogo", macchinario.city ? macchinario.city : macchinario.comuneDitta);
        this.$refs.window.setValue("annocostruzione", macchinario.anno);

        this.$refs.window.setValue("DenunciaINAIL", macchinario.denunciaINAIL);
        this.$refs.window.setValue("NumeroDenunciaINAIL", macchinario.numeroDenunciaINAIL);
        this.$refs.window.setValue("CausaNonDenunciaINAIL", macchinario.causaNonDenunciaINAIL);     

        /*switch (macchinario.tipoAttrCodice) {
          case "a1":
            this.$refs.window.setValue("IsRecipientiFluidi", "Y");
            break;
          case "a2":
            this.$refs.window.setValue("IsGeneratoriVaporiAcqua", "Y");
            break;
          case "a3":
            this.$refs.window.setValue("IsGeneratoriAcquaSurriscaldata", "Y");
            break;
          case "a4":
            this.$refs.window.setValue("IsTubazioniGasVaporiLiquidi", "Y");
            break;
          case "a6":
            this.$refs.window.setValue("IsForniIndustrieChimicheAffini", "Y");
            break;
          case "b":
            this.$refs.window.setValue("IsInsiemi", "Y");
            break;
        }*/
      } else if (datiVerbale.type == "C") {
        this.$refs.window.copyRecord();
      }
    }, 1000);
  },
};
</script>

<style>
</style>